import { Box, CircularProgress } from '@mui/material';
import isEmpty from 'lodash-es/isEmpty';
import { FC, useEffect, useState } from 'react';
import { getAllCV, ICandidate, IJob } from 'wisestep-api';
import { WsColors, WsDrawer } from 'wisestep-base';

import { useStatusActionPipelineContext } from '../../../context';

import JobSelection from './JobSelection';
// import UpdateProfile from './UpdateProfile';
import UpdateProfileNew from './UpdateProfileNew';

const MapAsLead: FC<{
  candidate: ICandidate | null;
  downloadSource?: string | null;
  job: IJob | null;
  close: () => void;
  showProfile?: boolean;
  doAssignmentCheck?: boolean;
  hideJobSelection?: boolean;
  isFrom?: string;
  heading?: string;
}> = ({
  candidate,
  downloadSource,
  job,
  close,
  showProfile = true,
  doAssignmentCheck = false,
  hideJobSelection = false,
  isFrom,
  heading,
}) => {
  const [jobEntity, setJobEntity] = useState<IJob | null>(null);
  const [openLeadForm, setOpenLeadForm] = useState<boolean>(true);
  const [check, setCheck] = useState<boolean>(false);
  const pipeline = useStatusActionPipelineContext();
  const closeModal = () => {
    setOpenLeadForm(false);
    close();
  };

  useEffect(() => setJobEntity(job), [job]);
  useEffect(() => {
    job && candidate && !doAssignmentCheck && setCheck(true);
    (async () => {
      const candidateId = candidate?.id ?? '';
      if (candidate && isEmpty(candidate?.resumeFileOriginalName)) {
        const allCVDetailsMapping = await getAllCV(candidateId);
        if (allCVDetailsMapping.data.length > 0) {
          const resumeData = allCVDetailsMapping.data[0];
          const resumeFieldsData = {
            resumeFileOriginalName: resumeData?.resumeFileOriginalName,
            resumeLocation: resumeData?.resumeLocation,
            resumeUploadedOn: resumeData?.resumeUploadedOn,
            candidateMappingId: '',
            email: '',
            gitHubLink: '',
            id: '',
            linkedInLink: '',
            phone: '',
            pinCode: '',
            content: '',
            s3FileName: '',
          };
          candidate.mappedCandidateResumes = [resumeFieldsData];
        }
      }
    })();
  }, [candidate, doAssignmentCheck, job]);

  return (
    <>
      {pipeline ? (
        <>
          {jobEntity && check ? (
            <UpdateProfileNew
              candidate={candidate}
              openUpdatePanel={openLeadForm}
              closeUpdatePanel={closeModal}
              mapAsLead={true}
              showProfile={showProfile}
              job={jobEntity}
              hideJobSelection={hideJobSelection}
              isFrom={isFrom}
              heading={heading}
              downloadSource={downloadSource}
            />
          ) : (
            <WsDrawer
              open={true}
              style={{ zIndex: '1300' }}
              hideHeader={true}
              onClose={closeModal}
              size="medium"
            >
              <JobSelection
                getJob={(job) => {
                  setJobEntity(job);
                  setCheck(true);
                }}
                job={job}
                onBackButton={closeModal}
              />
            </WsDrawer>
          )}
        </>
      ) : (
        <Box textAlign="center" pt="25%">
          <CircularProgress disableShrink sx={{ color: WsColors.TheBlues500 }} />
        </Box>
      )}
    </>
  );
};

export default MapAsLead;
